import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../modules/rackFormula';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {

	/** @namespace state.lists.rackFormulaIds **/
	let rackFormulas = [];
	if (state.lists.rackFormulaIds) {
		rackFormulas = _.map(state.lists.rackFormulaIds, id => state.maps.rackFormula[id]);
	}

	return {
		isSearchingRackFormulas : state.rackFormula.isSearching,
		searchFailedRackFormulas : state.rackFormula.searchFailed,
		rackFormulas : rackFormulas,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchRackFormulas : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
